import React, {
	createContext,
	useState,
	ReactNode,
	Dispatch,
	SetStateAction,
} from 'react';

export const StepContext = createContext<StepContextType | undefined>(
	undefined,
);

interface StepProviderProps {
	children: ReactNode;
}

export type StepContextType = {
	currentStep: number;

	setCurrentStep: Dispatch<SetStateAction<number>>;

	setTotalStep: Dispatch<SetStateAction<number>>;

	nextStep: () => void;

	previousStep: () => void;

	resetSteps: () => void;

	isLastStep: boolean;

	isFirstStep: boolean;
};

export const StepProvider: React.FC<StepProviderProps> = ({ children }) => {
	const [currentStep, setCurrentStep] = useState<number>(1);

	const [totalStep, setTotalStep] = useState(0);

	const isLastStep = currentStep === totalStep;

	const isFirstStep = currentStep === 1;

	const nextStep = () => {
		setCurrentStep((prev) => Math.min(prev + 1, totalStep));
	};

	const previousStep = () => {
		if (isFirstStep) return;

		setCurrentStep((prev) => Math.max(prev - 1, 1));
	};

	const resetSteps = () => {
		setCurrentStep(1);
	};

	const value: StepContextType = {
		currentStep,

		setCurrentStep,

		setTotalStep,

		nextStep,

		previousStep,

		resetSteps,

		isLastStep,

		isFirstStep,
	};

	return (
		<StepContext.Provider value={value}>{children}</StepContext.Provider>
	);
};
